/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Home_Shot_AltInputs */

const en_wc_home_shot_alt = /** @type {(inputs: Wc_Home_Shot_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The WordCraft app with the Home tab, live Styles gallery and Navigation pane open on a two-page document`)
};

/**
* | output |
* | --- |
* | "The WordCraft app with the Home tab, live Styles gallery and Navigation pane open on a two-page document" |
*
* @param {Wc_Home_Shot_AltInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_home_shot_alt = /** @type {((inputs?: Wc_Home_Shot_AltInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Home_Shot_AltInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_home_shot_alt(inputs)
});
export { wc_home_shot_alt as "wc.home.shot_alt" }